import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class LoteProdutoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let assProdutoLote = model;

        if (!assProdutoLote.idempresa) {
            refs.empresaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-empresa', true))
        }
        if (!assProdutoLote.lote || !assProdutoLote.lote.idlote) {
            refs.loteInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-necessario-lote', true))
        }
        if (!assProdutoLote.datafabricacao) {
            refs.dataFabricacaoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-necessario-data-fabricacao', true))
        }
        if (!assProdutoLote.datavalidade) {
            refs.dataValidadeInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-necessario-data-validade', true))
        }
        return validated;
    }

}